import {
  reducer as userInfoReducer,
  initialState as userInfoInitialState,
} from './profile/reducer';

import {
  reducer as contactsReducer,
  initialState as contactsInitialState,
} from './contact/reducer';

import {
  reducer as officialServicesReducer,
  initialState as officialServicesInitialState,
} from './officialServices/reducer';

import {
  reducer as userInfoRequestsReducer,
  initialState as userInfoRequestsInitialState,
} from './userInfoRequests/reducer';

export const reducer = (
  state = {
    userInfo: userInfoInitialState,
    contacts: contactsInitialState,
    officialServices: officialServicesInitialState,
    userInfoRequests: userInfoRequestsInitialState,
  },
  action
) => {
  switch (action.type) {
    default:
      return {
        ...state,
        userInfo: userInfoReducer(state.userInfo, action),
        contacts: contactsReducer(state.contacts, action),
        officialServices: officialServicesReducer(
          state.officialServices,
          action
        ),
        userInfoRequests: userInfoRequestsReducer(
          state.userInfoRequests,
          action
        ),
      };
  }
};
